import { render, staticRenderFns } from "./dataReport.vue?vue&type=template&id=764a5d81&scoped=true"
import script from "./dataReport.vue?vue&type=script&lang=js"
export * from "./dataReport.vue?vue&type=script&lang=js"
import style0 from "./dataReport.vue?vue&type=style&index=0&id=764a5d81&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764a5d81",
  null
  
)

export default component.exports